import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import * as Icons from "lucide-react";
import { ArrowLeft, ChevronRight } from "lucide-react";

export default function ExerciseLibrary() {
    const [list, setList] = useState([]);

    useEffect(() => {
        client.get("/exercises").then((r) => setList(r.data));
    }, []);

    return (
        <div className="px-5 pt-8 pb-8">
            <Link to="/app" className="inline-flex items-center text-zinc-500 hover:text-white">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Home</span>
            </Link>
            <div className="mt-4">
                <span className="label-cap text-xs text-neon-green">Library</span>
                <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Exercise Library</h1>
                <p className="text-zinc-400 text-sm mt-1">Form first. Reps second.</p>
            </div>

            <div className="mt-6 space-y-2">
                {list.map((e) => {
                    const Icon = Icons[e.icon] || Icons.Activity;
                    return (
                        <Link
                            key={e.id}
                            to={`/app/exercises/${e.id}`}
                            data-testid={`ex-${e.id}`}
                            className="surface-1 p-4 flex items-center gap-4 hover:border-neon-green transition-colors"
                        >
                            <div className="w-12 h-12 surface-3 flex items-center justify-center">
                                <Icon size={20} className="text-neon-green" />
                            </div>
                            <div className="flex-1">
                                <div className="font-display font-bold uppercase tracking-tight">{e.name}</div>
                                <div className="text-xs text-zinc-400 mt-1">{e.muscles.join(" · ")}</div>
                            </div>
                            <ChevronRight size={18} className="text-zinc-500" />
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
